import axios from 'axios';
import constantsFactory from '../../src/utils/constants';
import paramsHelper from '../../src/utils/paramsHelper';
// Action Types
import {
  STATUS_LOADING,
  LOAD_SEO_TEXT_REQUEST,
  LOAD_SEO_TEXT_SUCCESS,
  LOAD_SEO_TEXT_FAILURE,
  SET_SEO_TEXT,
} from '../actionTypes';

// private actions
const {API} = constantsFactory();
const URL = `${process.env.HOST}${API.SEO_TEXT_API}`;

/**
 * Async action creator - Load PLP SEO Text (depends on callAPIMiddleware)
 */
export function loadPlpSeoText(params) {
  const query = paramsHelper(params).objectToQueryString();

  return {
    // Types of actions to emit before and after
    types: [LOAD_SEO_TEXT_REQUEST, LOAD_SEO_TEXT_SUCCESS, LOAD_SEO_TEXT_FAILURE],
    // Check if we already have a cached result (optional):
    shouldCallAPI: (state) => state.plpSeoText.status !== STATUS_LOADING,
    // Perform the fetching:
    callAPI: () =>
      axios.get(`${URL}${query}`, {headers: {Accept: 'application/json'}, withCredentials: true}),
    // Arguments to inject in begin/end actions
    payload: {},
  };
}

export const setSeoText = (seoData) => ({
  type: SET_SEO_TEXT,
  payload: seoData,
});
